// extracted by mini-css-extract-plugin
export default {"footer":"SelectKeysSummaryTable_footer__GSMC0","summaryHeading":"SelectKeysSummaryTable_summaryHeading__QO7RZ","calcScoreRow":"SelectKeysSummaryTable_calcScoreRow__5iHZa"};